import { render, staticRenderFns } from "./BrandStocking.vue?vue&type=template&id=348194f4&scoped=true&"
import script from "./BrandStocking.vue?vue&type=script&lang=js&"
export * from "./BrandStocking.vue?vue&type=script&lang=js&"
import style0 from "./BrandStocking.vue?vue&type=style&index=0&id=348194f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348194f4",
  null
  
)

export default component.exports